import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { change, Field, formValueSelector } from 'redux-form'
import EyeMedFormButton from '../EyeMedFormButton'
import { AutoCompleteSelect, Input, Select } from '../../../../../../../../../../itrust_common/components/form'
import { humanize } from '../../../../../../../../../../itrust_common/components/HelperFunctions'
import { isRequired } from '../../../eyeMedHelper'
import { eyemedAllDiagnosesLoad } from '../../../../../../../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction'

function ContactLensesClaim(props) {
  const {
    claimFormTemplate,
    visionInsuranceClaimForm,
    formValues,
  } = props

  const dispatch = useDispatch()
  const fields = claimFormTemplate?.config?.contact_lens || []
  const [apiDiagnoses, setApiDiagnoses] = useState([])
  const [loading, setLoading] = useState(false)

  const getFieldValue = (label) => {
    const field = formValues?.[label]
    return field && typeof field === 'object' ? field.value : field
  }

  const procedureCode = getFieldValue('medically_necessary_procedure_code')
  const manufacturer = getFieldValue('manufacturer')

  const diagnosisConfig = (fields.find(f => f.label === 'medically_necessary_diagnosis_code')?.options || [])
    .find(o => o.key === procedureCode)
  const useApiDiagnoses = diagnosisConfig?.data_source === 'alldiagnoses'

  useEffect(() => {
    fields.forEach((field) => {
      if (!field.default_value) return
      const current = formValues?.[field.label]
      const currentValue = current && typeof current === 'object' ? current.value : current
      if (currentValue) return
      dispatch(change('EyeMedClaimForm', `contact_lenses.${field.label}.value`, field.default_value))
    })
  }, [fields, dispatch])

  useEffect(() => {
    if (!useApiDiagnoses || !visionInsuranceClaimForm?.id) return
    setLoading(true)
    dispatch(eyemedAllDiagnosesLoad(visionInsuranceClaimForm.id))
      .then((res) => setApiDiagnoses(res?.value?.data?.data?.alldiagnoses || []))
      .catch(() => setApiDiagnoses([]))
      .finally(() => setLoading(false))
  }, [useApiDiagnoses, procedureCode, visionInsuranceClaimForm?.id, dispatch])

  const matchesShowWhen = (showWhen) => {
    if (!showWhen) return true
    const { field, value, is_present } = showWhen
    const current = getFieldValue(field)
    if (is_present) return !!current
    return current === value
  }

  const getKeyedOptions = (field) => {
    const keyValue = field.label === 'brand' ? manufacturer : procedureCode
    const matched = (field.options || []).find(o => o.key === keyValue)
    if (!matched) return []
    if (matched.data_source === 'alldiagnoses') return apiDiagnoses
    return (matched.value || []).filter(o => o.value && matchesShowWhen(o.show_when))
  }

  const getOptions = (field) => {
    const options = field.options || []
    if (options[0]?.key !== undefined) return getKeyedOptions(field)

    const matchedConditional = options.filter(o => o.show_when && matchesShowWhen(o.show_when))
    if (matchedConditional.length) return matchedConditional

    return options.filter(o => !o.show_when)
  }

  return (
    <div className="row">
      <div className="col-10">
        <div className="bg-white p-6 border rounded">
          <h5 className="mb-4 font-weight-bold">Contact Lenses</h5>
          <div className="row">
            {fields.map((field, index) => {
              if (field.type === 'upload_file' || field.label === 'signers_name') return null
              if (!matchesShowWhen(field.show_when)) return null

              const label = field.required
                ? <>{humanize(field.label)} <span className="text-danger">*</span></>
                : humanize(field.label)

              if (field.type === 'dropdown') {
                const isDiagnosis = field.label === 'medically_necessary_diagnosis_code'
                const useSearchSelect = isDiagnosis && useApiDiagnoses
                const placeholder = loading && isDiagnosis
                  ? 'Loading...'
                  : field.default_value
                    ? undefined
                    : '--Please select--'

                if (useSearchSelect) {
                  return (
                    <div key={`${field.label}-${index}-api`} className="col-6 form-group mb-8 contact-lenses-diagnosis-select">
                      <label className="d-flex align-items-center">
                        {label}
                        {loading && <span className="spinner-border spinner-border-sm text-primary ml-2" />}
                      </label>
                      <Field
                        key={`diagnosis-api-${apiDiagnoses.length}`}
                        name={`${field.label}.value`}
                        component={AutoCompleteSelect}
                        data={getOptions(field)}
                        textField="label"
                        valueField="value"
                        disabled={loading}
                        hideResetButton
                        validate={isRequired(field)}
                        wrapperClasses="autocomplete"
                      />
                    </div>
                  )
                }

                return (
                  <Field
                    key={`${field.label}-${index}`}
                    name={`${field.label}.value`}
                    label={label}
                    component={Select}
                    data={getOptions(field)}
                    textField="label"
                    valueField="value"
                    placeholder={placeholder}
                    disabled={loading && isDiagnosis}
                    validate={isRequired(field)}
                    wrapperClasses="form-group mb-8 col-6"
                  />
                )
              }

              return (
                <Field
                  key={`${field.label}-${index}`}
                  name={field.label}
                  label={label}
                  component={Input}
                  className="form-control"
                  validate={isRequired(field)}
                  wrapperClasses="form-group mb-8 col-6"
                />
              )
            })}
          </div>
          <EyeMedFormButton currentModule="Contact Lenses" />
        </div>
      </div>
      <div className="col-2">
        <div className="bg-white border rounded-lg">
          <div className="d-flex flex-column align-items-center">
            <span className="py-5 px-6 w-100 text-primary">Contact Lenses</span>
          </div>
        </div>
      </div>
    </div>
  )
}

const selector = formValueSelector('EyeMedClaimForm')

export default connect((state) => ({
  formValues: selector(state, 'contact_lenses'),
}))(ContactLensesClaim)
